export default "/_next/static/images/061ea67adcb1525dd1dbcdded56c940b.png";